import React from 'react';
import { GenericOption } from '../GenericOption/GenericOption';
import { radioButtonPropTypes } from './RadioButton.types';
export const RadioButton = React.forwardRef(function RadioButton(props, ref) {
    return React.createElement(GenericOption, { ...props, type: "radio", ref: ref });
});
RadioButton.propTypes = radioButtonPropTypes;
//# sourceMappingURL=RadioButton.js.map